@for (
  item of filtered | skipPickedByPhotographer: photographerPreConfig;
  track trackOption($index, item)
) {
  <ng-container [formGroup]="model">
    <ng-container>
      @let itemType = item.type;

      @switch (itemType) {
        @case ('list') {
          <h3 class="{{ fixingAttributes }}{{ !item.fixing }}">
            <span [zalamoTooltip]="item.description | langPicker | async">{{
              item.label | langPicker | async
            }}</span>
            @if (fixingAttributes && !item.fixing) {
              <div class="errorCircle"></div>
            }
          </h3>
          <lib-product-param-picker
            [formControlName]="item.customId"
            [options]="item.options"
          ></lib-product-param-picker>
        }
        @case ('size') {
          <h3 class="{{ fixingAttributes }}{{ !item.fixing }}">
            <span [zalamoTooltip]="item.description | langPicker | async">{{
              item.label | langPicker | async
            }}</span>
            @if (fixingAttributes && !item.fixing) {
              <div class="errorCircle"></div>
            }
          </h3>
          <lib-product-param-picker
            [formControlName]="item.customId"
            [options]="item.options"
          ></lib-product-param-picker>
        }

        @case ('boolean') {
          <div>
            <lib-checkbox
              [zalamoTooltip]="item.description | langPicker | async"
              [formControlName]="item.customId"
              >{{ item.label | langPicker | async }}</lib-checkbox
            >
          </div>
        }

        @case ('counter') {
          @if (item.counterConfig.takeCountFromImagesCount !== true) {
            <h3 class="{{ fixingAttributes }}{{ !item.fixing }}">
              <span [zalamoTooltip]="item.description | langPicker | async">{{
                item.label | langPicker | async
              }}</span>
              @if (fixingAttributes && !item.fixing) {
                <div class="errorCircle"></div>
              }
            </h3>
          }
          @if (
            item.counterConfig.takeCountFromImagesCount !== true ||
            hideImageRelatedCounters === false
          ) {
            <div class="counter">
              <app-change-number
                [formControlName]="item.customId"
                [maxNumber]="item.counterConfig.max"
                [minNumber]="
                  item
                    | calculateMinValueIncludingPhotographerConfig
                      : photographerPreConfig
                "
              ></app-change-number>
              <p>
                <span translate>clhrodz1e000008mpbi4k0l20</span>&nbsp;
                <strong>{{
                  item
                    | calculateMinValueIncludingPhotographerConfig
                      : photographerPreConfig
                }}</strong
                >&nbsp;
                <span
                  translate
                  [params]="{
                    min: item.counterConfig.min,
                    max: item.counterConfig.max,
                  }"
                  >clhroei0v000108mp7htk4nak</span
                >&nbsp; <strong>{{ item.counterConfig.max }}</strong>
              </p>
            </div>
          }
        }
        @case ('text') {
          <mat-form-field libZalamoField>
            <mat-label>{{ item.label | langPicker | async }}</mat-label>
            <textarea
              matInput
              [formControlName]="item.customId"
              [minLength]="item.textConfig.min"
              [maxLength]="item.textConfig.max"
            ></textarea>
            <mat-hint>
              <span translate>clhss8ao8000008l05m7s2qrz</span>&nbsp;
              <strong>{{ item.textConfig.min }}</strong
              >&nbsp;
              <span
                translate
                [params]="{
                  min: item.counterConfig.min,
                  max: item.counterConfig.max,
                }"
                >clhroei0v000108mp7htk4nak</span
              >&nbsp;
              <strong>{{ item.textConfig.max }}</strong>
            </mat-hint>
            <lib-zalamo-field-decoration></lib-zalamo-field-decoration
          ></mat-form-field>
        }
      }

      @if (item.type === 'file') {
        <button mat-flat-button>
          <input
            type="file"
            [accept]="'.' + item.fileConfig?.extensions.join(',.')"
          />
        </button>
      }
    </ng-container>
  </ng-container>
}
<!--{{ model.valid | json }}-->
<!---->
